import { useContext, useMemo } from 'react';
import GlobalContext, { DefaultGlobalContextValue } from '../../common/context/global';

export default function useConfig() {
  const { config = DefaultGlobalContextValue.config } = useContext(GlobalContext);
  return useMemo(() => config, [config]);
}
